/* Busca por rotulo de time .
 *
 * A busca da Shopify indexa o titulo REAL do produto, que nao tem rotulo de time.
 * Aqui o termo buscado vira um REDIRECT pra colecao correspondente. Quando o termo
 * nao casa com nada, a busca normal da Shopify roda como sempre.
 *
 * O MAPA NAO MORA AQUI: vem do mesmo servico externo dos rotulos (data-ui-labels no
 * <html>), pra que nenhum termo de marca precise existir dentro do tema. Fica em cache
 * no navegador por 24h. Em /search e pedido na hora; nas outras paginas, so quando o
 * cliente encosta na busca. Servico fora do ar: a busca padrao da Shopify assume.
 */
(function () {
  "use strict";

  /* Palavras que a pessoa digita junto do time e que nao ajudam a identificar:
     "<termo> jersey", "<termo> shirt 26/27" e "<termo>" tem que cair no mesmo lugar. */
  var RUIDO = [
    "shirt", "shirts", "jersey", "jerseys", "kit", "kits", "camisa", "camisas",
    "football", "soccer", "fc", "cf", "club", "team", "home", "away", "third",
    "men", "mens", "women", "womens", "kid", "kids", "player", "fan", "retro", "new"
  ];

  function normalizar(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .replace(/^\s+|\s+$/g, "");
  }

  /* Indice termo -> colecao, montado uma vez a partir do mapa invertido. */
  var INDICE = null;
  function montarIndice() {
    if (INDICE) return INDICE;
    var bruto = window.__MD_SEARCH_MAP;
    if (!bruto) return null;
    INDICE = {};
    for (var colecao in bruto) {
      /* chave com ":" e carga extra que viaja no mesmo mapa (hoje o "x:bloqueio"),
         nao colecao: sem esta guarda, buscar o termo bloqueado viraria um desvio pra
         uma colecao que nao existe */
      if (colecao.indexOf(":") > -1) continue;
      var termos = bruto[colecao];
      for (var i = 0; i < termos.length; i++) {
        var k = normalizar(termos[i]);
        if (k && !INDICE[k]) INDICE[k] = colecao;
      }
    }
    return INDICE;
  }

  /* Tenta, em ordem: termo inteiro -> termo sem as palavras de ruido -> cada pedaco de
     2 palavras -> cada palavra isolada. A primeira que casar ganha. */
  function resolver(termo) {
    var idx = montarIndice();
    if (!idx) return null;

    var t = normalizar(termo);
    if (!t) return null;
    if (idx[t]) return idx[t];

    var partes = t.split(" ");
    /* Fora do match exato, token puramente numerico e descartado: "<termo> shirt 26/27"
       vira "<termo> 26 27" e o par "26 27" casaria com a colecao de temporada em vez do time.
       Quem busca so "1986" continua atendido, porque o termo inteiro e testado antes disto. */
    var limpo = partes.filter(function (p) {
      return RUIDO.indexOf(p) === -1 && p.length > 1 && !/^[0-9]+$/.test(p);
    });

    if (limpo.length) {
      var semRuido = limpo.join(" ");
      if (idx[semRuido]) return idx[semRuido];

      /* pares consecutivos: pega "<termo composto>" dentro de "<termo composto> away kit" */
      for (var i = 0; i < limpo.length - 1; i++) {
        var par = limpo[i] + " " + limpo[i + 1];
        if (idx[par]) return idx[par];
      }
      /* palavra isolada, da mais longa pra mais curta (a mais especifica primeiro) */
      var sozinhas = limpo.slice().sort(function (a, b) { return b.length - a.length; });
      for (var j = 0; j < sozinhas.length; j++) {
        if (idx[sozinhas[j]]) return idx[sozinhas[j]];
      }
    }
    return null;
  }

  /* ================= casamento por PARTE do nome (2026-09-05) =================

     O resolver() acima exige o rotulo inteiro: o rotulo completo acha, o pedaco nao. Mas
     o cliente digita pedaco, e o titulo que ele LE na tela (rotulo + o resto do nome do
     produto) nao existe na Shopify - o rotulo entra no navegador. Resultado medido em
     05/09/2026: um prefixo de 3 letras devolvia 3 produtos (os que tinham essas letras no
     titulo real, tipo um cachecol), e nenhuma camisa do que a pessoa procurava.

     Agora, quando o nome inteiro nao casa, o termo e testado como INICIO DE PALAVRA
     dos apelidos: um prefixo curto pega o rotulo que comeca por ele, e um prefixo mais
     longo pega um conjunto menor. Inicio de palavra, e nao pedaco solto no meio, porque
     pedaco solto vira ruido: medido no mapa vivo, "an" no meio da palavra casa 399
     colecoes contra 10 no inicio.

     Um time casado -> a colecao dele. Varios -> a grade filtrada pelos varios, que a
     Shopify resolve como OU (medido: 10 filtros de uma vez, 140 produtos, HTTP 200).
     O filtro so entende o CODIGO do time, entao aqui so entram as chaves de 3 digitos
     do mapa - e, como sempre, nenhum nome de time e escrito no tema: tudo vem do mapa
     do Worker e viaja como codigo.
  */
  var PREFIXO_MIN = 3;
  /* teto de seguranca: acima disto o termo e generico demais pra virar desvio, e a
     busca normal da Shopify assume (a URL tambem nao cresce sem limite) */
  var TETO_TIMES = 20;
  var INDICE_PREFIXO = null;

  function montarIndicePrefixo() {
    if (INDICE_PREFIXO) return INDICE_PREFIXO;
    var bruto = window.__MD_SEARCH_MAP;
    if (!bruto) return null;
    INDICE_PREFIXO = [];
    for (var col in bruto) {
      /* so time: o filtro de equipe nao entende chave composta como "045-home" */
      if (!/^[0-9]{3}$/.test(col)) continue;
      /*
        So o PRIMEIRO termo, que e o rotulo oficial. Os outros sao apelidos, e apelido
        cita cidade, torcida e rival: casar pedaco contra eles trazia entrada errada junto.
        Medido no mapa vivo em 05/09/2026: quatro prefixos de teste traziam de 1 a 4
        entradas extras cada um, sempre por causa de apelido, nunca do rotulo oficial.
        So com o rotulo oficial, cada um desses devolve so quem a pessoa procurava.
        Os apelidos continuam valendo inteiros, pelo resolver() la de cima: quem digita
        um apelido conhecido cai na entrada certa como sempre caiu.
      */
      var oficial = normalizar((bruto[col] || [])[0] || "");
      if (oficial) INDICE_PREFIXO.push({ col: col, termos: [oficial] });
    }
    return INDICE_PREFIXO;
  }

  function porPrefixo(termo) {
    var t = normalizar(termo);
    if (t.length < PREFIXO_MIN) return [];
    var idx = montarIndicePrefixo();
    if (!idx) return [];
    var achados = [];
    for (var i = 0; i < idx.length; i++) {
      var termos = idx[i].termos;
      for (var j = 0; j < termos.length; j++) {
        var nome = termos[j];
        /* comeco do apelido, ou comeco de qualquer palavra dele */
        if (nome.lastIndexOf(t, 0) === 0 || nome.indexOf(" " + t) > -1) {
          achados.push(idx[i].col);
          break;
        }
      }
    }
    return achados;
  }

  /*
    Quando o desvio por PARTE do nome pode entrar.

    Casar pedaco de nome e poderoso e perigoso na mesma medida: muito apelido de time
    comeca com palavra comum. Medido no mapa vivo em 05/09/2026, aceitar todo casamento
    sequestrava 13 de 39 termos de loja - quem buscasse "red" caia numa grade de times
    em vez de ver produtos vermelhos, "home" ia parar num time so.

    A trava e a propria busca da Shopify, nao uma lista de palavras proibidas (que
    envelhece e esquece caso). Contagens medidas na loja no mesmo dia:

      pedaco de nome de time    bar 3 | ajax 4 | liver 5 | che 6 | arse 10
      palavra comum de loja     jacket 15 | cap 23 | new 29 | green 114 | black 213
                                third 175 | club 254 | white 341 | training 493
                                away 523 | home 536 | red 808 | blue 802

    Ou seja: quando a busca ja devolve uma tela cheia, ela esta funcionando e ninguem
    deve mexer. Quando devolve quase nada, e sinal de que o nome que a pessoa digitou
    nao existe no titulo real - e ai o mapa do Worker resolve. O corte ficava em 12, na
    folga entre os dois grupos, e subiu para 30 em 11/09/2026 a pedido do cliente, para
    "manchester" (12 resultados) voltar a desviar. CUSTO ACEITO e medido no mesmo dia:
    "cap" (23 resultados) passa a casar com 743 = cape verde, entao quem busca bone
    cai na colecao do pais. "jacket" (15) e "new" (29) nao casam com time nenhum.

    O total vem do Liquid da propria pagina de busca (window.__MD_BUSCA_TOTAL). Quem
    nao sabe o total - o submit do formulario, que decide antes de haver pagina - fica
    so com o nome inteiro, exatamente como era antes.
  */
  var TETO_RESULTADOS = 30;

  /* Devolve o destino do termo, ou null pra deixar a busca da Shopify seguir. */
  function destinoDe(termo, total) {
    var exato = resolver(termo);
    if (exato) return { colecao: exato };

    /* sem total em maos, nao ha como saber se a busca ja esta boa: nao desvia */
    if (typeof total !== "number" || total >= TETO_RESULTADOS) return null;

    var times = porPrefixo(termo);
    if (!times.length || times.length > TETO_TIMES) return null;
    if (times.length === 1) return { colecao: times[0] };
    return { times: times };
  }

  function irPara(destino, termo) {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (raiz.charAt(raiz.length - 1) !== "/") raiz += "/";
    /* ui_q preserva o que a pessoa digitou, util pra medir busca no analytics */
    var marca = "ui_q=" + encodeURIComponent(termo);

    if (destino.colecao) {
      window.location.replace(raiz + "collections/" + destino.colecao + "?" + marca);
      return;
    }

    var partes = [];
    for (var i = 0; i < destino.times.length; i++) {
      partes.push("filter.p.m.custom.equipe=" + encodeURIComponent(destino.times[i]));
    }
    partes.push(marca);
    window.location.replace(raiz + "collections/all?" + partes.join("&"));
  }

  /* ---- 1) Ja estamos em /search?q=... : redireciona antes de pintar "sem resultados" ---- */
  /*
    Marca posta pelo inline do <head> da pagina de busca: enquanto ela esta la, a frase
    "0 resultados" fica escondida. Some assim que se decide que NAO ha desvio - quando
    ha, a pagina troca antes de qualquer coisa aparecer.
  */
  function liberarMensagem() {
    var d = document.documentElement;
    if (d) d.classList.remove("ui-busca-decidindo");
  }

  function tratarPaginaDeBusca() {
    if (!/\/search\b/.test(window.location.pathname)) return;
    var q = new URLSearchParams(window.location.search).get("q");
    if (!q) return;
    /* aqui vale esperar a rede: sem isso a pessoa ve "nenhum resultado" a toa */
    obterMapa().then(function (mapa) {
      var total = typeof window.__MD_BUSCA_TOTAL === "number" ? window.__MD_BUSCA_TOTAL : null;
      var destino = mapa ? destinoDe(q, total) : null;
      if (destino) {
        irPara(destino, q);
        return;
      }
      liberarMensagem();
    }, liberarMensagem);
  }

  /* ---- 2) Submissao do formulario de busca em qualquer pagina ---- */
  function interceptarFormularios() {
    document.addEventListener(
      "submit",
      function (ev) {
        var form = ev.target;
        if (!form || !form.action || form.action.indexOf("/search") === -1) return;
        var campo = form.querySelector('input[name="q"]');
        if (!campo || !campo.value) return;
        /* so intercepta se o mapa ja estiver em maos; senao deixa a busca normal seguir */
        if (!window.__MD_SEARCH_MAP) return;
        var destino = destinoDe(campo.value);
        if (destino) {
          ev.preventDefault();
          irPara(destino, campo.value);
        }
      },
      true
    );
  }

  /* ---- 3) O mapa vem do servico externo, com cache de 24h no navegador ---- */
  var CACHE_KEY = "ui_searchmap_v1";
  var TTL = 24 * 3600 * 1000;

  function doCache() {
    try {
      var cru = localStorage.getItem(CACHE_KEY);
      if (!cru) return null;
      var o = JSON.parse(cru);
      if (!o || !o.map || Date.now() - o.ts > TTL) return null;
      return o.map;
    } catch (e) { return null; }
  }

  function guardar(map) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), map: map })); } catch (e) {}
  }

  /* Cache servido: confere em segundo plano se o mapa mudou, senao um time novo so
     entraria na busca 24h depois. O Worker responde 304 quando nada mudou, entao a
     conferencia custa alguns bytes em vez dos 152KB. A busca em curso usa o mapa que
     ja estava em maos; a proxima ja usa o novo. */
  function revalidar() {
    if (window.__mdMapaRevalidado) return;
    window.__mdMapaRevalidado = true;
    var base = document.documentElement.getAttribute("data-ui-labels");
    if (!base || typeof fetch !== "function") return;
    fetch(base + "/search-map", { credentials: "omit", cache: "no-cache" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return;
        guardar(j);
        window.__MD_SEARCH_MAP = j;
      })
      .catch(function () {});
  }

  /* devolve promessa do mapa: cache -> rede. Falhou, resolve null e a busca da Shopify roda. */
  function obterMapa() {
    var local = doCache();
    if (local) { window.__MD_SEARCH_MAP = local; revalidar(); return Promise.resolve(local); }
    if (window.__mdMapaPromessa) return window.__mdMapaPromessa;

    var base = document.documentElement.getAttribute("data-ui-labels");
    if (!base || typeof fetch !== "function") return Promise.resolve(null);

    window.__mdMapaPromessa = fetch(base + "/search-map", { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return null;
        guardar(j);
        window.__MD_SEARCH_MAP = j;
        return j;
      })
      .catch(function () { return null; });
    return window.__mdMapaPromessa;
  }

  /* fora de /search o mapa so e pedido quando o cliente encosta na busca */
  function carregarSobDemanda() { obterMapa(); }

  function armarGatilhos() {
    var eventos = ["focusin", "pointerdown", "keydown"];
    for (var i = 0; i < eventos.length; i++) {
      document.addEventListener(
        eventos[i],
        function (ev) {
          var alvo = ev.target;
          if (!alvo || !alvo.closest) return;
          if (alvo.closest('form[action*="/search"], [href*="/search"], input[name="q"], .header__icon--search, [class*="search"]')) {
            carregarSobDemanda();
          }
        },
        true
      );
    }
  }

  /* ---- 4) Sugestoes de time enquanto se digita ----

     A fonte nao e a rede: sao os itens do PROPRIO MENU, que ja estao no HTML desta
     pagina com o escudo da colecao (data-ui-menu-src) e com o rotulo que o Worker
     escreveu. Custo: nenhuma requisicao nova, so as poucas imagens das linhas exibidas.
     Item cujo rotulo ainda e o codigo (dicionario nao chegou) fica de fora, pra nunca
     aparecer numero na tela.
  */
  var SUG_MAX = 6;

  function itensDoMenu() {
    var fotos = document.querySelectorAll("[data-ui-menu-src]");
    var vistos = {};
    var itens = [];
    for (var i = 0; i < fotos.length; i++) {
      var img = fotos[i];
      var a = img.closest ? img.closest("a") : null;
      if (!a) continue;
      var href = a.getAttribute("href");
      var nome = (a.textContent || "").replace(/\s+/g, " ").trim();
      if (!href || !nome || vistos[href] || /^[0-9]+$/.test(nome)) continue;
      vistos[href] = true;
      itens.push({ href: href, nome: nome, foto: img.getAttribute("data-ui-menu-src") });
    }
    return itens;
  }

  /* casa por QUALQUER PARTE do nome (decisao do cliente), com quem comeca pelo termo na frente */
  function sugerir(termo) {
    var t = normalizar(termo);
    if (t.length < 2) return [];
    var itens = itensDoMenu();
    var comeca = [];
    var contem = [];
    for (var i = 0; i < itens.length; i++) {
      var n = normalizar(itens[i].nome);
      var pos = n.indexOf(t);
      if (pos === 0) comeca.push(itens[i]);
      else if (pos > 0) contem.push(itens[i]);
    }
    return comeca.concat(contem).slice(0, SUG_MAX);
  }

  /* Marca o painel quando ha time na tela. So o computador usa isso: la a sugestao
     abre a grade na primeira linha e empurra o resto pra baixo, e sem a marca a grade
     fica como sempre foi. No celular a classe nao muda nada. */
  function marcarPainel(caixa, tem) {
    var painel = caixa.closest ? caixa.closest(".ui-busca__conteudo") : null;
    if (painel) painel.classList.toggle("ui-busca__conteudo--com-times", !!tem);
  }

  function pintarSugestoes() {
    var caixa = document.querySelector(".ui-busca__times");
    var campo = document.querySelector(".ui-busca__input");
    if (!caixa || !campo) return;

    var lista = sugerir(campo.value);
    caixa.innerHTML = "";
    if (!lista.length) {
      caixa.hidden = true;
      marcarPainel(caixa, false);
      return;
    }

    var ul = document.createElement("ul");
    ul.className = "ui-busca__times-lista list-unstyled";
    ul.setAttribute("role", "list");

    for (var i = 0; i < lista.length; i++) {
      var it = lista[i];
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.className = "ui-busca__time link";
      a.href = it.href;

      if (it.foto) {
        var img = document.createElement("img");
        img.className = "ui-menu-foto";
        img.src = it.foto;
        img.alt = "";
        img.width = 28;
        img.height = 28;
        img.loading = "lazy";
        img.decoding = "async";
        a.appendChild(img);
      }

      var span = document.createElement("span");
      /* textContent, nunca innerHTML: o rotulo vem de fora do tema */
      span.textContent = it.nome;
      a.appendChild(span);

      li.appendChild(a);
      ul.appendChild(li);
    }

    caixa.appendChild(ul);
    caixa.hidden = false;
    marcarPainel(caixa, true);
  }

  function armarSugestoes() {
    var pendente = null;
    function agendar() {
      if (pendente) clearTimeout(pendente);
      pendente = setTimeout(function () {
        pendente = null;
        try { pintarSugestoes(); } catch (e) {}
      }, 80);
    }
    /* delegacao no document: funciona mesmo com este arquivo rodando antes do <body> */
    document.addEventListener("input", function (ev) {
      var alvo = ev.target;
      if (alvo && alvo.classList && alvo.classList.contains("ui-busca__input")) agendar();
    });
    /* o botao de limpar dispara reset, que nao dispara input */
    document.addEventListener("reset", function () { setTimeout(agendar, 0); }, true);
  }

  /* ---- 4) Sugestao bloqueada nao chega aos olhos do cliente ----

     A Shopify monta as sugestoes de busca a partir do HISTORICO do que os clientes
     digitaram, e esse historico nao tem painel nem no admin nem no Search & Discovery.
     Marca que saiu do catalogo continua sendo oferecida: medido em 05/09/2026, digitar
     "b", "ba" ou "bal" ainda trazia o nome de uma marca retirada em 22/08 - a mesma que
     custou a suspensao do Google Ads em 27/08. Aqui ela e removida da lista antes de a
     tela pintar.

     A lista de termos vem do Worker (chave "x:bloqueio" do mapa de busca), nunca do
     tema: marca de terceiro nao pode ficar gravada dentro da Shopify.
  */
  function termosBloqueados() {
    var mapa = window.__MD_SEARCH_MAP;
    var bruta = mapa && mapa["x:bloqueio"];
    if (!bruta || !bruta.length) return null;
    var lista = [];
    for (var i = 0; i < bruta.length; i++) {
      var norm = normalizar(bruta[i]);
      if (norm) lista.push(norm);
    }
    return lista.length ? lista : null;
  }

  /*
    Casamento por PALAVRA INTEIRA, com o texto cercado de espacos dos dois lados. E o
    que garante que bloquear um termo nunca derruba a sugestao vizinha: " ball " nao
    contem " balmain ", e o mesmo vale pra "black", "backpack", "bag", "blue", "bottle"
    e "burgundy". Cercar tambem faz um termo de duas palavras funcionar sem codigo extra.
  */
  function bloqueado(texto, lista) {
    var n = normalizar(texto);
    if (!n) return false;
    n = " " + n + " ";
    for (var i = 0; i < lista.length; i++) {
      if (n.indexOf(" " + lista[i] + " ") > -1) return true;
    }
    return false;
  }

  function limparSugestoes() {
    var lista = termosBloqueados();
    if (!lista) return;

    /* so as sugestoes de TEXTO: o id e o que separa elas das colecoes, que a Shopify
       renderiza dentro da mesma lista */
    var itens = document.querySelectorAll('li[id^="predictive-search-option-query-"]');
    var tirou = 0;
    for (var i = 0; i < itens.length; i++) {
      var alvo = itens[i].querySelector("[aria-label]");
      var texto = alvo ? alvo.getAttribute("aria-label") : itens[i].textContent;
      if (bloqueado(texto, lista)) {
        itens[i].parentNode.removeChild(itens[i]);
        tirou++;
      }
    }
    if (!tirou) return;

    /*
      Se a unica sugestao era a bloqueada, sobra o titulo "Suggestions" apontando pro
      vazio. Nesse caso o grupo inteiro sai, e o painel recebe a MESMA marca que o Liquid
      poria se a Shopify nao tivesse mandado sugestao nenhuma - e por ela que, no
      computador, os produtos sobem pra primeira coluna.
    */
    var grupos = document.querySelectorAll(".ui-res__coluna--sugestoes");
    for (var g = 0; g < grupos.length; g++) {
      var ul = grupos[g].querySelector("ul");
      if (ul && ul.children.length) continue;
      /*
        display inline, e nao so o atributo hidden: o CSS do tema da display:flex a
        .ui-res__coluna, e regra de folha de estilo vence o hidden do navegador (que e
        so uma regra do user-agent). Medido em 05/09/2026: com hidden sozinho, o titulo
        "Top Suggestions" continuava na tela apontando pro vazio. O atributo fica junto
        pela semantica, pra quem le a pagina por leitor de tela.
      */
      grupos[g].hidden = true;
      grupos[g].style.display = "none";
      var painel = grupos[g].closest ? grupos[g].closest(".ui-res") : null;
      if (painel) painel.classList.add("ui-res--sem-sugestoes");
    }
  }

  /*
    O observador olha SO as caixas do predictive search, nao o documento: elas sao duas
    no maximo e trocam de conteudo por innerHTML a cada tecla. O retorno do callback
    acontece antes do proximo quadro, entao o item bloqueado nao chega a piscar.
  */
  function armarFiltroDeSugestoes() {
    if (!window.MutationObserver) return true;
    var caixas = document.querySelectorAll("[data-predictive-search]");
    if (!caixas.length) return false;
    for (var i = 0; i < caixas.length; i++) {
      if (caixas[i].getAttribute("data-ui-filtrado")) continue;
      caixas[i].setAttribute("data-ui-filtrado", "1");
      new MutationObserver(limparSugestoes).observe(caixas[i], { childList: true, subtree: true });
    }
    limparSugestoes();
    return true;
  }

  function iniciar() {
    tratarPaginaDeBusca();
    interceptarFormularios();
    armarGatilhos();
    armarSugestoes();
    /* na pagina de busca este arquivo roda no <head>, antes de existir corpo: se as
       caixas ainda nao nasceram, o armamento espera o DOM */
    if (!armarFiltroDeSugestoes()) {
      document.addEventListener("DOMContentLoaded", armarFiltroDeSugestoes);
    }
  }

  /*
    Sem esperar o DOM. Nada aqui depende de elemento na tela (os ouvintes sao no
    document, em captura), e na pagina de busca este arquivo passa a ser carregado no
    <head> sem defer: esperar o DOMContentLoaded ali deixaria a pagina de "0 resultados"
    pintar antes do desvio, que e exatamente o defeito que isto corrige.
  */
  iniciar();
})();
